export const blockIconsBusinessandpaymentsLeaderboardNew = (
	<span className='material-symbols-outlined'>leaderboard</span>
);
